export const CACHE_KEY = 'music-quiz-page';
